<template>
   <div>
       <Breadcrumb :headers="headers"></Breadcrumb>
       
        <List 
            url="getOrderingList"
            deleteUrl="deleteOrdering" 
            :data="searchData" 
            :tanle="tanle" 
            :update="updateList" 
            :afterList="dealListData"
            :operat="operat"
            @add="add"
            @download="download"
            @edit="edit"
            @info="info"
            @setStatus="setStatus"
            :isAdd="this.type === 'null' || this.type === '1' || this.type === '2'"
            >
            <div slot="Filter">
                <label style="margin-left:10px;">Ordering Status：</label>
                <el-select v-model="searchData.Status" placeholder="">
                    <el-option
                        v-for="item in statusList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <el-input v-model="searchData.Key" placeholder="Company Name/Country" style="width:300px;margin-left:20px;"></el-input>
                <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
        </List>
            <UpdateBox
            :updateType="updateType"
            :initForm="updateForm"
            v-if="updateBlock"
            @close="updateBlock = false"
            @update="updateList++"
            ></UpdateBox>
            <UpdateBoxInfo
            :updateType="updateType"
            :initForm="updateForm"
            v-if="updateBlockInfo"
            @close="updateBlockInfo = false"
            @update="updateList++"
            ></UpdateBoxInfo>
        <SetStatusBox :id="statusForm.id" :status="statusForm.Status" v-if="statusBlock" @close="statusBlock = false" @update="updateList++"></SetStatusBox>
    <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
   </div>
</template>
<script>
import List from "../components/common/List.vue";
import SetStatusBox from "@/components/Ordering/SetStatusBox.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { ORDERSTATUS,orderStatusList } from "@/components/Ordering/data.js";
import { unshiftAll } from "@/methods/selection.js";
import UpdateBox from "../components/Ordering/UpdateBox.vue";
import UpdateBoxInfo from "../components/Ordering/UpdateBoxInfo.vue";
export default {
    components:{
        List,
        SetStatusBox,
        Breadcrumb,
        UpdateBox,
        UpdateBoxInfo
    },
    data () {
        return {
            tanle:[{name:"ID",label:"ID",width:"100px"},{name:"CompanyName",label:"Company Name",width:"200px"},{name:"Country",label:"Country"} ,{name:"devices",label:"Devices",type:1,width:'200px'},
                /* {name:"OrderingDescription",label:"Ordering Description"}, */{name:"ExpectDate",label:"Required Shipment Date",width:"250px"},{name:"StatusName",label:"Status",width:'150px'},{name:"FileName",label:"File Name",type:"file",width:"300px"}],
            searchData:{
                Key:"",
                Status:"all"
            },
            type:"",
            updateList:0,
            updateType: "add",
            iframeUrl:"",
            uploadBlock:false,
            updateForm: {},
            updateBlock: false,
            updateBlockInfo: false,
            headers:[{label:"Home",path:"/dashboard"},{label:"Ordering",path:"/ordering"}],
            statusList:unshiftAll(orderStatusList),
            operat:[],
            statusForm:{
                id:"",
                Status:""
            },
            statusBlock:false,
            customerList:[]
        };
        
    },
    mounted () {
        this.type = localStorage.getItem("type");
        if (this.type === '0' || this.type === '1' || this.type === '2')
        {
            this.operat.push({
                text:"Status",
                eventName:"setStatus",
                type:'danger',
                method (data) {
                    return (data.Status !== "2"  );
                }
            });
        }

        if (this.type === 'null' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            });
            this.operat.push(  {
                text:"Edit",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "2");
                } 
            });
        }

        if (this.type === '0' || this.type === 'null' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text:"Info",
                eventName:"info",
                type:'primary'/* ,
                method (data) {
                    return (data.Status !== "1");
                }  */
            });
        }
    },
    methods:{
        dealListData (data) {
            for(let i in data) {
                data[i].StatusName = ORDERSTATUS[data[i].Status];
                data[i].ExpectDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data[i].ExpectTime);
                data[i].ExpectDate = data[i].ExpectDate[0];
                data[i].ExpectDate = data[i].ExpectDate.replace(/"/g, "");
            }
            return data;
        },
        add () {
            this.updateForm = {
                ExpectTime:"",
                CompanyName:"",
                OrderingDescription:"",
                Country:"",
                Devices:[{
                    ProductNumber:"",
                    Number:""
                }]
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit (val) {
            /* val.SalesRepresentative = val.AccountID; */
            this.updateForm = val;//当前菜单项的数据
            // console.log(val.Devices)
            this.updateForm.ExpectTime = new Date(val.ExpectTime); 
            this.updateType = "edit";
            this.updateBlock = true;
        },
        info (val) {
            /* val.SalesRepresentative = val.AccountID; */
            this.updateForm = val;
            this.updateForm.ExpectTime = new Date(val.ExpectTime); 
            this.updateType = "info";
            this.updateBlockInfo = true;
        },
        setStatus (val) {
            this.statusForm.id = val.ID;
            this.statusForm.Status = val.Status;
            this.statusBlock = true;
        },
        uploadFiles () {
            this.uploadBlock = true;
        },
        closeUploadFiles() {
            this.uploadBlock = false;
        },
        download (data) {
            // console.log(data)
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/ordering/${data}`;
        }
    }
};
</script>
